"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M3.406 3L2 6.604v14.732h5V24h2.813l2.656-2.664h4.062L22 15.85V3H3.406zm16.719 11.91L17 18.045h-5l-2.656 2.664v-2.664H5.125V4.88h15v10.03zM17 8.485v5.485h-1.875V8.485H17zm-5 0v5.485h-1.875V8.485H12z" }), "Twitch");
//# sourceMappingURL=Twitch.js.map